import api from '@pray/shared/utils/api';
import type { ListResponse } from '@pray/shared/utils/api/types/response';

import type { TagLocaleResponse } from './types';

export async function listTagLocales(tagId: string) {
  const url = `/web/studio/tags/${tagId}/locales`;

  const response = await api.executeGetRequest<ListResponse<TagLocaleResponse>>(url);

  return response;
}
